import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import { formatDate, generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import type { CampaignInspectionModel } from '@models/types'

import { generateUrls } from '@hooks/useCampaign'
import useCampaignInspection from '@hooks/useCampaignInspection'
import useSelector from '@hooks/useSelector'

import { combineAgentNames } from '@functions/agent'

interface CampaignInspectionListItemProps {
  campaignInspection: CampaignInspectionModel,
}

const CampaignInspectionListItem = (props: CampaignInspectionListItemProps) => {
  const { campaignInspection } = props
  const {
    campaign,
    // @ts-expect-error TS2339
    campaign: { agent_ids },
    campaignInspection: { times },
  } = useCampaignInspection(campaignInspection)

  const agents = useSelector(reduxState => reduxState.entities.agents)

  const { campaignEditDetailsUrl } = generateUrls(campaign)

  const startTime = times?.inspection.start
  const endTime = times?.inspection.end

  return (
    <DashboardModuleListItem
      href={`${campaignEditDetailsUrl}?redirect=${generateRedirectUrl()}`}
      secondaryText={(
        <>
          <FontAwesomeIcon icon={faUser} /> {combineAgentNames({ agentIds: agent_ids, agents, joiningWord: '&' })}
        </>
      )}
      // @ts-expect-error TS2339
      title={campaign.title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`${formatDate(startTime, 'HH:mm', 'h:mm a')} - ${formatDate(endTime, 'HH:mm', 'h:mm a')}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CampaignInspectionListItem
